import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo } from 'react';
import { useHistory } from 'quartz-routing/react-router';
import { parse } from 'hub-http/helpers/params';
import { getCurrentURL } from 'framework-listing-lib/internal/deepLink/utils';
export default function useQueryParams() {
  "use memo";

  const $ = _c(2);
  const {
    location
  } = useHistory();
  let t0;
  if ($[0] !== location.search) {
    t0 = parse(location.search.substring(1));
    $[0] = location.search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useRemoveQueryParams() {
  "use memo";

  const $ = _c(4);
  const {
    location,
    replace
  } = useHistory();
  let t0;
  if ($[0] !== location.search || $[1] !== location.state || $[2] !== replace) {
    t0 = params => {
      const url = getCurrentURL();
      for (const param of params) {
        url.searchParams.delete(param);
      }
      const nextSearch = url.searchParams.toString();
      if (nextSearch !== location.search) {
        replace({
          search: url.searchParams.toString(),
          state: location.state
        });
      }
    };
    $[0] = location.search;
    $[1] = location.state;
    $[2] = replace;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}